import React, { useEffect } from 'react'
import './projects.scss'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


export const Projects = () => {

  // useEffect(() => {
  //   console.log(document.getElementsByClassName('carousel')[0])
  //   document.getElementsByClassName('carousel')[0].owlCarousel({
  //     margin: 20,
  //     loop: true,
  //     autoplaytimeout: 2000,
  //     autoplauHoverPause: true,
  //     responsive: {
  //       0: {
  //         items: 1,
  //         nav: false
  //       },
  //       600: {
  //         items: 2,
  //         nav: false
  //       },
  //       1000: {
  //         items: 3,
  //         nav: false
  //       }

  //     }
  //   })
  // }, [])

  return (
    <section class="teams" id="projects">
      <div class="max-width">
        <h2 class="title">My projects</h2>

        {/* <div class="carousel owl-carousel">
          <div class="card">
            <div class="box">
              <img src="images/profilepic.jpg" alt="" />
              <div class="text">Someone name</div>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>

            </div>
          </div>
          <div class="card">
            <div class="box">
              <img src="images/profilepic.jpg" alt="" />
              <div class="text">Someone name</div>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>

            </div>
          </div>
          <div class="card">
            <div class="box">
              <img src="images/profilepic.jpg" alt="" />
              <div class="text">Someone name</div>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>

            </div>
          </div>
          <div class="card">
            <div class="box">
              <img src="images/profilepic.jpg" alt="" />
              <div class="text">Someone name</div>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>

            </div>
          </div>
          <div class="card">
            <div class="box">
              <img src="images/profilepic.jpg" alt="" />
              <div class="text">Someone name</div>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>
            </div>
          </div>
        </div>
         */}
        <div className="centerCarousel">
          <div class="owlCarousel-container">
            <OwlCarousel items={1} className='owl-theme' autoplay loop margin={10} nav>
              <div class="card">
                <div class="box">
                  <img src="images/ChatProject.png" alt="" />
                  <div class="text">Chat Application</div>
                </div>
              </div>
              <div class="card">
                <div class="box">
                  <img src="images/blueprintProject.png" alt="" />
                  <div class="text">Electronic Blueprint Generator</div>
                </div>
              </div>
              <div class="card">
                <div class="box">
                  <img src="images/ToolkitProject.png" alt="" />
                  <div class="text">Whatsapp Toolkit</div>
                </div>
              </div>

            </OwlCarousel>
          </div>
        </div>
      </div>
    </section >
  )
}
